import React, { useEffect, useRef, useState } from 'react'

const ACCEPTABLE = /^\d*\.?\d{0,2}$/

function penceToDisplay(pence) {
  if (pence === '' || pence === null || pence === undefined) return ''
  const num = Number(pence)
  if (Number.isNaN(num)) return ''
  return (num / 100).toFixed(2)
}

function displayToPence(text) {
  if (text === '' || text === null || text === undefined) return ''
  const num = parseFloat(text)
  if (Number.isNaN(num)) return ''
  return Math.round(num * 100)
}

export default function CurrencyInput({
  inputId,
  name,
  value,
  onChange,
  placeholder = '0.00',
  required,
  className,
  ...props
}) {
  const [draft, setDraft] = useState(() => penceToDisplay(value))
  const lastValueRef = useRef(value)

  useEffect(() => {
    if (value !== lastValueRef.current) {
      setDraft(penceToDisplay(value))
      lastValueRef.current = value
    }
  }, [value])

  const handleChange = (e) => {
    const text = e.target.value
    if (text !== '' && !ACCEPTABLE.test(text)) return
    setDraft(text)
    const pence = displayToPence(text)
    lastValueRef.current = pence
    onChange({ target: { name, value: pence } })
  }

  const handleBlur = () => {
    if (draft === '') return
    const pence = displayToPence(draft)
    if (pence === '') return
    setDraft(penceToDisplay(pence))
  }

  return (
    <div className="relative rounded-md shadow-sm">
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <span className="text-gray-500 sm:text-sm">£</span>
      </div>
      <input
        id={inputId}
        name={name}
        type="text"
        inputMode="decimal"
        autoComplete="off"
        value={draft}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        required={required}
        className={`${className} pl-7`}
        {...props}
      />
    </div>
  )
}
